import {
  UPDATE_PLAN_LOADING,
  UPDATE_PLAN_SUCCESS,
  UPDATE_PLAN_FAILED,
} from "../types";
import { PlanResponse } from "../../models/PlanResponse";

interface UpdatePlanState {
  plan: PlanResponse | null;
  loading: boolean;
  error: string | null;
  success: boolean;
}

const initialState: UpdatePlanState = {
  plan: null,
  loading: false,
  error: null,
  success: false,
};

type Action =
  | { type: typeof UPDATE_PLAN_LOADING }
  | { type: typeof UPDATE_PLAN_SUCCESS; payload: PlanResponse }
  | { type: typeof UPDATE_PLAN_FAILED; error: string };

export const updateRecurringPlanReducer = (
  state = initialState,
  action: Action
): UpdatePlanState => {
  switch (action.type) {
    case UPDATE_PLAN_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case UPDATE_PLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        plan: action.payload,
        error: null,
        success: true,
      };

    case UPDATE_PLAN_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};
